/*******************************************************************************
* @license
* Copyright (c) 2016 - present Accedo. All Rights Reserved.
* 
* This source code, its use, and distribution, is subject to the terms
* and conditions of the applicable license agreement.
* 
* Accedo Build XDK Device Package - LG webOS (@accedo/xdk-device-lg-webos) 4.1.1
* 
*******************************************************************************/
import{DeviceConfig}from"@accedo/xdk-config";import ID from"./id";const xdkDeviceLgWebOS={id:ID,detection:()=>import("./detection.js"),defaultConfig:()=>import("./defaultConfig.js"),DevicePackage:()=>import("./DevicePackage.js")};export default new DeviceConfig(xdkDeviceLgWebOS);